import {FC, lazy, Suspense} from 'react';
import {createBrowserRouter, Navigate, Outlet, redirect} from 'react-router-dom';

import {User} from "../domain/User";
import {AuthPath, MainPath} from "../app/cfg/RoutePath";
import Loadable from "../components/LoadableComponent";
import Main from "../components/Main";
import {queryToObject} from "../utils/UrlUtil";
import {find} from "lodash";
import {generateServiceAuthUrl} from "../app/state/auth";
import {paramsStorage} from "../domain/ParamStorage";

// service-application-ui T5: the development-only harness, lazy and
// conditional so it never enters the production bundle.
const DevApplicationPreview = process.env.NODE_ENV === 'development'
  ? (() => {
    const Lazy = lazy(() => import('../components/MyServices/application/ApplicationPreview'));
    return () => <Suspense fallback={null}><Lazy/></Suspense>;
  })()
  : () => null;

//const SignUpForm = Loadable(lazy(() => import("../components/auth/SignUpForm")));
const Auth = Loadable(lazy(() => import("../components/Auth")));

const Access = Loadable(lazy(() => import('../components/Access')));
const MyServices = Loadable(lazy(() => import('../components/MyServices')));
const Denied = Loadable(lazy(() => import('../components/Dinied')));

export const createRoutes = (root: string, user?: User) => {

  const authGuard = async () => {
    if (!user) {
      console.log('Guard works and redirects to login');
      return redirect(`${root}${AuthPath.LOGIN}`);
    }
    const serviceDid = paramsStorage.get();
    if (serviceDid) {
      console.log('we have serviceDid', serviceDid);
      const record = find(user.serviceRecords, (r) => r.serviceDid === serviceDid);
      if (!record) {
        console.log('so, we have no access', user.serviceRecords);
        paramsStorage.drop();
        return redirect(`${root}${MainPath.DENIED}`);
      } else {
        const url = await generateServiceAuthUrl(record.endpointUrl, serviceDid);
        console.log('we have access url', url);
        // return redirect(url);
        window.open(url, '_self');
      }
    }
    return null;
  };

  const isLoggedIn = async () => {
    if (user) {
      return redirect(`${root}${MainPath.ACCESS}`);
    }

    return null;
  };

  return createBrowserRouter([
    {
      path: `${root}`,
      element: <Main><Outlet/></Main>,
      children: [
        {
          path: AuthPath.LOGIN,
          loader: isLoggedIn,
          element: <Auth />
        },
        {
          path: MainPath.DENIED,
          element: <Denied />,
        },
        // service-application-ui T5: a development-only harness for the
        // application page, outside the auth guard so it can be LOOKED at.
        // Compiled out of production: the import is conditional, and the
        // route is registered only in development.
        ...(process.env.NODE_ENV === 'development' ? [{
          path: '__preview/application',
          element: <DevApplicationPreview />,
        }] : []),
        {
          path: '',
          element: <Outlet/>,
          loader: authGuard,
          children: [
            {path: '', index: true, element: <Access />},
            {
              path: `${MainPath.ACCESS}`,
              element: <Access />,
            },
            {
              path: `${MainPath.MY_SERVICES}`,
              element: <MyServices />,
            },
          ]
        },
        {path: '*', element: <Navigate to="" />}
      ]
    }
  ]);
}
